export default "__VITE_ASSET__CJw_KrJm__"